import React from 'react';

export const SvgPaginationPrevDisable = () => {
  return (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.445336 7.88456C0.257866 7.69703 0.15255 7.44272 0.15255 7.17756C0.15255 6.91239 0.257866 6.65809 0.445337 6.47056L6.10234 0.813559C6.19458 0.718048 6.30493 0.641866 6.42693 0.589457C6.54894 0.537048 6.68016 0.509462 6.81294 0.508308C6.94571 0.507154 7.07739 0.532456 7.20029 0.582737C7.32319 0.633018 7.43484 0.707271 7.52873 0.801164C7.62262 0.895056 7.69688 1.00671 7.74716 1.1296C7.79744 1.2525 7.82274 1.38418 7.82159 1.51696C7.82043 1.64974 7.79285 1.78096 7.74044 1.90296C7.68803 2.02497 7.61185 2.13531 7.51634 2.22756L2.56634 7.17756L7.51634 12.1276C7.69849 12.3162 7.79929 12.5688 7.79701 12.831C7.79473 13.0932 7.68956 13.344 7.50415 13.5294C7.31875 13.7148 7.06793 13.82 6.80574 13.8222C6.54354 13.8245 6.29094 13.7237 6.10234 13.5416L0.445336 7.88456Z"
        fill="#959091"
      />
    </svg>
  );
};

export const SvgPaginationPrev = () => {
  return (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.445336 7.88456C0.257866 7.69703 0.15255 7.44272 0.15255 7.17756C0.15255 6.91239 0.257866 6.65809 0.445337 6.47056L6.10234 0.813559C6.19458 0.718048 6.30493 0.641866 6.42693 0.589457C6.54894 0.537048 6.68016 0.509462 6.81294 0.508308C6.94571 0.507154 7.07739 0.532456 7.20029 0.582737C7.32319 0.633018 7.43484 0.707271 7.52873 0.801164C7.62262 0.895056 7.69688 1.00671 7.74716 1.1296C7.79744 1.2525 7.82274 1.38418 7.82159 1.51696C7.82043 1.64974 7.79285 1.78096 7.74044 1.90296C7.68803 2.02497 7.61185 2.13531 7.51634 2.22756L2.56634 7.17756L7.51634 12.1276C7.69849 12.3162 7.79929 12.5688 7.79701 12.831C7.79473 13.0932 7.68956 13.344 7.50415 13.5294C7.31875 13.7148 7.06793 13.82 6.80574 13.8222C6.54354 13.8245 6.29094 13.7237 6.10234 13.5416L0.445336 7.88456Z"
        fill="#514B4D"
      />
    </svg>
  );
};
